var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hmim-svg",
    width: 22,
    height: 22,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-none",
    d: "M6.12432 8.61411C6.12432 8.09864 5.70652 7.68105 5.19126 7.68105C4.67581 7.68105 4.2582 8.09866 4.2582 8.61411V19.0548C4.2582 20.7233 5.61073 22.076 7.2793 22.076H17.7204C19.3889 22.076 20.7415 20.7233 20.7415 19.0548V8.61411C20.7415 8.09864 20.3237 7.68105 19.8084 7.68105C19.2932 7.68105 18.8754 8.09864 18.8754 8.61411V19.0548C18.8754 19.6928 18.3584 20.2099 17.7204 20.2099H7.2793C6.64152 20.2099 6.12432 19.6928 6.12432 19.0548V8.61411Z",
    fill: "#5D5FEF",
    stroke: "#5D5FEF",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-none",
    d: "M5.14551 20.905V8.87568L12.5084 3.92603L19.8544 8.87568L19.6069 20.905H5.14551Z",
    fill: "#5D5FEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-none svg-fill-white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6279 13.356C10.6279 12.3226 11.4656 11.4849 12.499 11.4849C13.5324 11.4849 14.3701 12.3226 14.3701 13.356C14.3701 14.3893 13.5324 15.2271 12.499 15.2271C11.4656 15.2271 10.6279 14.3893 10.6279 13.356Z",
    fill: "#F2F1FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "svg-stroke-none",
    d: "M13.1626 4.99564L13.1626 4.99564L22.4061 11.466C22.8283 11.7615 23.41 11.6588 23.7055 11.2367C24.001 10.8145 23.8983 10.2328 23.4762 9.93723L23.3902 10.0601L23.4762 9.93723L14.2329 3.46692L14.2329 3.46691C13.1925 2.73877 11.8079 2.73876 10.7677 3.46691L10.8537 3.5898L10.7677 3.46692L1.52443 9.93723L1.52442 9.93723C1.10227 10.2328 0.999572 10.8145 1.29512 11.2367C1.59065 11.6588 2.17236 11.7615 2.59453 11.466L11.8378 4.99564L11.8378 4.99564C12.2355 4.71718 12.7649 4.71718 13.1626 4.99564Z",
    fill: "#5D5FEF",
    stroke: "#5D5FEF",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconFilled);
export default __webpack_public_path__ + "static/media/homeIconFilled.37e9bb3f2caf845ee94260315a761be9.svg";
export { ForwardRef as ReactComponent };